import { useLocalStorageClear } from '@/components/Functional/hooks/useLocalStorageClear'
import { authV2Url } from '@/components/Functional/lib/authUrls'
import { useCampaignSlug } from '../hooks-core/useCampaignSlug'

/**
 * Auth v2 サーバの `POST /{campaignSlug}/auth/logout` を呼び出すフック。
 *
 * - httpOnly Cookie（AccessToken / IdToken / RefreshToken）を期限切れ Cookie で上書きして削除
 * - LocalStorage をクリア
 *
 * @example
 * const { logout } = useLogout()
 * await logout()
 */
export const useLogout = (): { logout: () => Promise<void> } => {
  const { campaignSlug } = useCampaignSlug()
  const clear = useLocalStorageClear()

  const logout = async (): Promise<void> => {
    const url = authV2Url.logout(campaignSlug)

    try {
      await fetch(url, {
        method: 'POST',
        credentials: 'include',
      })
    } catch (error) {
      console.error('[useLogout] logout API error:', error)
    } finally {
      clear()
    }
  }

  return { logout }
}
